import axios from 'axios'
import Vue from 'vue'

export default class Http{
	constructor(config = {}) {
		const {header = {}, helper = {}, ...otherConfig} = config
		this.helper = helper
		this.vueInstance = null
	    this.instance = axios.create({
			withCredentials: false,
			headers: {
				'content-type': 'application/json;charset=UTF-8',
				...header
			},
			...otherConfig
		})
		
		this.setInstance()
	}
	
	getInstance(){
		return this.instance
	}
	
	setVueInstance(vueInstance){
		vueInstance && (vueInstance instanceof Vue) && (this.vueInstance = vueInstance)
	}
	
	setInstance(){
		const {responseInterceptor: userDefinedResponseInterceptor} = this.helper
		
		this.instance.interceptors.request.use(config => {
			return config
		}, error => {
			return Promise.reject(error)
		})
		
		this.instance.interceptors.response.use(response => {
			let {status, data} = response, success = false
			
			if(status === 200){
				success = true
				if(userDefinedResponseInterceptor){
					return userDefinedResponseInterceptor(data, this.vueInstance)
				}else{
					return data
				}
			}
		}, error => {
			this.vueInstance.$toast({
				message: '系统异常',
				icon: 'close'
			})
			return Promise.reject(error)
		})
	}
}

class Config{
	constructor({
		header = {},
		withCredentials = false,
		auth = {},
		timeout = 10000
	} = {}) {
		this.header = header
	    this.withCredentials = withCredentials
		this.auth = auth
		this.timeout = timeout
	}
}

export const HttpConfig = Config